import styled from "styled-components";

const c = {
  text: "rgba(0,0,0,0.78)",
  textSoft: "rgba(0,0,0,0.65)",
};

export const Wrap = styled.section`
  width: 100%;
  padding: 70px 0 40px;
`;

export const Header = styled.div`
  max-width: 900px;
  margin: 0 auto 50px;
  text-align: center;
  padding: 0 20px;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: "Cormorant Garamond", serif;
  font-size: 44px;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: ${c.text};

  @media (max-width: 768px) {
    font-size: 25px;
  }
`;

export const Subtitle = styled.div`
  margin-top: 12px;
  font-family: "Ephesis", cursive;
  font-size: 28px;
  color: ${c.textSoft};

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const Description = styled.p`
  margin-top: 28px;
  font-size: 20px;
  line-height: 1.8;
  color: ${c.textSoft};
  font-family: "Cormorant Garamond", serif;

  @media (max-width: 768px) {
    line-height: 1.4;
  }
`;

export const Viewport = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 8px 0 24px;
`;

export const Track = styled.div`
  display: flex;
  width: max-content;

  gap: ${({ $gap }) => $gap}px;
  padding: 0 ${({ $gap }) => $gap}px;

  will-change: transform;
`;

export const Card = styled.article`
  flex: 0 0 auto;
  width: var(--cardW, 380px);
  text-align: center;
`;

export const ImgWrap = styled.div`
  width: 100%;
  height: var(--cardH, 420px);
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 600ms ease;

  ${Card}:hover & {
    transform: scale(1.03);
  }
`;

export const Caption = styled.div`
  margin-top: 16px;
  font-size: 13px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${c.textSoft};
`;

/* ARROWS */
export const ArrowBase = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;

  width: 48px;
  height: 48px;

  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: rgba(255, 255, 255, 0.92);
  cursor: pointer;

  font-size: 26px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.75);

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.25s ease;

  &:hover {
    background: black;
    color: white;
  }
`;

export const ArrowLeft = styled(ArrowBase)`
  left: 16px;
`;

export const ArrowRight = styled(ArrowBase)`
  right: 16px;
`;
